import { render, staticRenderFns } from "./MergePasien.vue?vue&type=template&id=14ade0e2"
import script from "./MergePasien.vue?vue&type=script&lang=js"
export * from "./MergePasien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14ade0e2')) {
      api.createRecord('14ade0e2', component.options)
    } else {
      api.reload('14ade0e2', component.options)
    }
    module.hot.accept("./MergePasien.vue?vue&type=template&id=14ade0e2", function () {
      api.rerender('14ade0e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/master_pasien/MergePasien.vue"
export default component.exports